// import { resolve } from 'core-js/fn/promise'
import config from '../config'
var AWS = require('aws-sdk')
//
export function uploadFileS3(objectFile) {
  AWS.config.update(config.S3Config)
  const s3 = new AWS.S3({ apiVersion: '2006-03-01' })
  // call S3 to retrieve upload file to specified bucket
  const uploadParams = { Bucket: 'taxi-fiable-public', Key: '', Body: '' }
  console.log('s3 => ', s3)
  uploadParams.Key = new Date().getTime().toString() + '.' + objectFile.fileExtension
  uploadParams.Body = objectFile.fileUploaded
  if (objectFile.fileExtension === 'pdf') {
    uploadParams.ContentType = 'application/pdf'
    uploadParams.Bucket = `taxicontigo-public/${process.env.NODE_ENV}/archivos`
  } else if (objectFile.fileExtension === 'png' || objectFile.fileExtension === 'jpg' || objectFile.fileExtension === 'jpeg') {
    uploadParams.ContentType = 'image/*'
    uploadParams.Bucket = `taxicontigo-public/${process.env.NODE_ENV}/imagenes`
  } else if (objectFile.fileExtension === 'kmz') {
    uploadParams.ContentType = 'binary/octet-stream'
    uploadParams.Key = objectFile.fileUploaded.name
    uploadParams.Bucket = `taxicontigo-private/${process.env.NODE_ENV}/kmz`
  }
  // https://taxicontigo-public.s3.us-east-1.amazonaws.com/prod/imagenes/533_1626975925519.jpeg
  return new Promise((resolve, reject) => {
    s3.upload(uploadParams, function (err, data) {
      if (err) {
        reject(err)
      } else {
        resolve(data)
      }
    })
  })
}
